/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  SiteConfiguration,
  SiteConfigurationBody,
  SiteConfigurationKey,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    SiteConfigurationFromJSON,
    SiteConfigurationToJSON,
    SiteConfigurationBodyFromJSON,
    SiteConfigurationBodyToJSON,
    SiteConfigurationKeyFromJSON,
    SiteConfigurationKeyToJSON,
} from '../models/index';

export interface GetSiteConfigurationsRequest {
    configKey?: SiteConfigurationKey;
}

export interface UpdateSiteConfigurationsRequest {
    siteConfigurationBody?: SiteConfigurationBody;
}

/**
 * SiteConfigurationsApi - interface
 * 
 * @export
 * @interface SiteConfigurationsApiInterface
 */
export interface SiteConfigurationsApiInterface {
    /**
     * Used to get site configurations.
     * @param {SiteConfigurationKey} [configKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteConfigurationsApiInterface
     */
    getSiteConfigurationsRaw(requestParameters: GetSiteConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteConfiguration>>;

    /**
     * Used to get site configurations.
     */
    getSiteConfigurations(requestParameters: GetSiteConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteConfiguration>;

    /**
     * Used by admins to create / update site configuration.
     * @param {SiteConfigurationBody} [siteConfigurationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteConfigurationsApiInterface
     */
    updateSiteConfigurationsRaw(requestParameters: UpdateSiteConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to create / update site configuration.
     */
    updateSiteConfigurations(requestParameters: UpdateSiteConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SiteConfigurationsApi extends runtime.BaseAPI implements SiteConfigurationsApiInterface {

    /**
     * Used to get site configurations.
     */
    async getSiteConfigurationsRaw(requestParameters: GetSiteConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteConfiguration>> {
        const queryParameters: any = {};

        if (requestParameters['configKey'] != null) {
            queryParameters['configKey'] = requestParameters['configKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/site-configurations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteConfigurationFromJSON(jsonValue));
    }

    /**
     * Used to get site configurations.
     */
    async getSiteConfigurations(requestParameters: GetSiteConfigurationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteConfiguration> {
        const response = await this.getSiteConfigurationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to create / update site configuration.
     */
    async updateSiteConfigurationsRaw(requestParameters: UpdateSiteConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/site-configurations`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SiteConfigurationBodyToJSON(requestParameters['siteConfigurationBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to create / update site configuration.
     */
    async updateSiteConfigurations(requestParameters: UpdateSiteConfigurationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSiteConfigurationsRaw(requestParameters, initOverrides);
    }

}
